import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AdCardListItem from '../../../../../../../features/components/AdCardListItem'
import AdCardMetric from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric'
import InstagramPostPreview from '../../../../../../../features/components/FacebookPreviews/InstagramPostPreview'

import { renderMetricValue } from '../../../../../../../features/components/AdCardListItem/AdCardMetrics/AdCardMetric/renderMetricValue'
import { getFormattedInstagramSocialPostData } from './helpers'

import useAdCardMetricsClasses from '../../../../../../CampaignsSummary/AdsList/FacebookAdsPreviewList/FacebookAdCardListItem/AdCardMetrics/styles'
import useAdPreviewStyles from '../../../../../../CampaignsSummary/AdsList/FacebookAdsPreviewList/FacebookAdCardListItem/AdCardPreview/styles'
import useStyles from '../../styles'

const InstagramSocialPostCard = ({ post, facebookPageData }) => {
  const adCardMetricsClasses = useAdCardMetricsClasses()
  const adPreviewClasses = useAdPreviewStyles({})
  const classes = useStyles()

  const formattedPost = useMemo(
    () => getFormattedInstagramSocialPostData(post, facebookPageData),
    [facebookPageData, post]
  )

  const { impressions, reach, frequency, likeCount, engagement, videoViews } = formattedPost

  return (
    <AdCardListItem>
      <div
        className={classnames(
          adPreviewClasses.adPreviewWrapper,
          classes.adPreviewWrapper,
          classes.instagramAdPreviewWrapper
        )}
      >
        <InstagramPostPreview post={formattedPost} />
      </div>
      <AdCardMetric>
        <div>Total Impressions</div>
        <div>{renderMetricValue(impressions)}</div>
      </AdCardMetric>
      <AdCardMetric>
        <div>
          Reach <span className={adCardMetricsClasses.metricAdditional}>(Frequency)</span>
        </div>
        <div>
          {renderMetricValue(reach)}{' '}
          <span className={adCardMetricsClasses.metricAdditional}>({renderMetricValue(frequency)})</span>
        </div>
      </AdCardMetric>
      <AdCardMetric>
        <div>Likes</div>
        <div>{renderMetricValue(likeCount)}</div>
      </AdCardMetric>
      <AdCardMetric>
        <div>Engagement</div>
        <div>{renderMetricValue(engagement)}</div>
      </AdCardMetric>
      {!!videoViews && (
        <AdCardMetric>
          <div>Video Views</div>
          <div>{renderMetricValue(videoViews)}</div>
        </AdCardMetric>
      )}
    </AdCardListItem>
  )
}

InstagramSocialPostCard.propTypes = {
  post: PropTypes.object,
  facebookPageData: PropTypes.object
}

export default InstagramSocialPostCard
